import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

export class CompanyPolicyFM {
	hasInitialFiles: boolean;
	fileName: Nullable<string>;
	files: File[];
	deleteFile: boolean;

	static toRM(form: CompanyPolicyFM) {
		return {
			files: form.files ?? [],
			deleteFile: form.deleteFile ?? false,
		};
	}

	static fromVM(company: CompanyViewModel): CompanyPolicyFM {
		return {
			fileName: company.companyPolicyAttachmentName,
			files: [],
			deleteFile: false,
			hasInitialFiles: !!company.companyPolicyAttachmentName,
		};
	}

	static validate(values: CompanyPolicyFM) {
		const errors: ValidationErrors = {};

		if (!values.files?.length && !values.deleteFile) {
			errors.files = 'Must input some files.';
		}

		if (!values.files?.length && values.deleteFile && !values.hasInitialFiles) {
			errors.files = 'Must input some files.';
		}

		return errors;
	}
}
